import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useSelector } from "react-redux";
import { isEmpty} from '../modules/appLibrary';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';

//--------------------------------------------------------
//  Entery Remarks
//
//  fnc
//  def：カラム情報
//  dataRef : 入力データ
//--------------------------------------------------------
// Event
//  changewidth
//  ValueChanged
//  ※データをメモリに保存　rerender防止対策
//--------------------------------------------------------
export default function EntryRemarks(props) {

    const formstatus = useSelector(state => state.form.status);
    const warndescription = useSelector(state => state.form.warndiscription);
    const entrylock = useSelector(state => state.form.entryformlock);
    const inputrender = useSelector(state => state.form.entryinputrender);
    const account = useSelector(state => state.user.account);
    const [value, setValue] = useState('');
    const [warning, setwarning] = useState('');


    useEffect(() => {
        if (isEmpty(props.dataRef.current)) return;
        //外部で変更された値を反映
        if (props.def.columnid in props.dataRef.current) {
            if (value !== props.dataRef.current[props.def.columnid]) {
                ShowValue();
            }
        }
    }, [inputrender]);

    useEffect(() => {
        if (isEmpty(warndescription)) return;
        let result = warndescription.find(e => e.col === props.def.columnid);
        if (isEmpty(result)) {
            if (!isEmpty(warning)) setwarning("");
            return;
        }
        setwarning(result.message);
    }, [warndescription]);

    useEffect(() => {
        ShowValue();
    }, []);

    function ShowValue() {
        let data = props.dataRef.current;
        if (!isEmpty(data)) {
            setValue(data[props.def.columnid]);
        } else {
            setValue("");
        }
    }

    function onChange(id, value) {
        //変更データをメモリ上に保存
        let data = props.dataRef.current;
        if (isEmpty(data)) data = {};
        data[id] = value;
        props.dataRef.current = data;
    }


    function onInputChange(newvalue) {
        setValue(newvalue);
        props.fnc.current.modify();
        if (!isEmpty(props.modify)) props.modifyRef.current = true;
        onChange(props.def.columnid, newvalue);
    }

    function WarnTip() {
        return (
            <Tooltip title={warning}>
                <div style={{ position: 'absolute', top: -3, left: -8, cursor: 'pointer' }}>
                    <span class="material-icons warning">announcement</span>
                </div>
            </Tooltip>
        );
    }
    function isReadOnly() {
        if (entrylock) return true;
        if (isEmpty(props.def)) return false;
        return props.def.locked || entrylock || (props.def.primary && formstatus === 'ENTRY FORM');
    }
    return (
        <div id={props.id} style={{ marginTop: 10, marginLeft: 10, marginRight: 20, marginBottom: 0 }}>
           <TextField
               value={value}
                readOnly={isReadOnly}
               onChange={(e) => onInputChange(e.target.value)}
               fullWidth
               multiline
               inputProps={{ style: { fontSize: 12 } }}
               variant="outlined"
           />
       </div>
    );
}